import { ReactNode, useMemo, useState } from 'react';

import { Button, Result } from '@aicon-dev/caas-ui';
import { Modal } from 'antd-mobile';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { useCatch } from '~/libs/hooks/useCatch';

import { ErrorCoverBox, ErrorCoverPre } from './ErrorCover.styled';

interface ErrorCoverProps {
  children: ReactNode;
}

const FallbackComponent = (props: FallbackProps) => {
  const { error, resetErrorBoundary } = props;
  const { t } = useTranslation('error_page');
  const { catchError } = useCatch();

  const [openDetail, setOpenDetail] = useState(false);

  const errorMessage = useMemo(() => {
    if (!error) return undefined;
    const [message] = catchError(error, { silence: true });
    return message;
  }, [error, catchError]);

  return (
    <ErrorCoverBox>
      <Result size="medium" status="error" title={errorMessage}>
        <Button key="detail" onClick={() => setOpenDetail(true)}>
          {t('error_page:error_detail_info_title')}
        </Button>

        <Button variant="filled" color="primary" key="reset" onClick={resetErrorBoundary}>
          {t('error_page:retry')}
        </Button>
      </Result>

      <Modal
        visible={openDetail}
        title={t('error_page:error_detail_info_title')}
        onClose={() => setOpenDetail(false)}
        {...{ children: <ErrorCoverPre>{error.stack}</ErrorCoverPre> }}
      />
    </ErrorCoverBox>
  );
};

export const ErrorCover = (props: ErrorCoverProps) => {
  const { children } = props;

  return <ErrorBoundary FallbackComponent={FallbackComponent}>{children}</ErrorBoundary>;
};
